import React from 'react';
import { LinkShareIcon } from '../../../wag-react/next-components/icons';
import { useClipboard } from '../../../wag-react/common/hooks/useClipboard';
import { Button } from '../../../wag-react/next-components/button';
import { Box } from '../../../wag-react/next-components/box';
export type LinkShareButtonProps = {
  shareUrl: string;
};
export const LinkShareButton = ({
  shareUrl
}: LinkShareButtonProps) => {
  const {
    target,
    copy
  } = useClipboard();
  return <Button title="Link Share Button" onClick={async () => {
    await copy();
  }} data-sentry-element="Button" data-sentry-component="LinkShareButton" data-sentry-source-file="index.tsx">
      <Box as="input" ref={target} defaultValue={shareUrl} style={{
      position: 'absolute',
      left: '-1000px',
      top: '-1000px',
      visibility: 'hidden'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx" />
      <LinkShareIcon data-sentry-element="LinkShareIcon" data-sentry-source-file="index.tsx" />
    </Button>;
};